import { transient, autoinject } from "aurelia-framework";
import { BannerGrouping, BannerDescDialogModel, BannerRoleCountrySanctioned } from "../../../../../models/vessels/vessel.models";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import * as Enumerable from "linq";
import { UserClaimsService } from "../../../../../services/authentication/user-claims.service";
import { Claims } from "../../../../../constants/authentication/claims";
import { StringUtilities } from "../../../../../utilities/strings";

@autoinject
@transient()
export class BannerDescDialog {
    
    public bannerDescDialog: BannerDescDialogModel;
    public bannerType: string;
    public bannerListType: string;
    public rightShipUser: boolean;
    public isSanctionedBanner: boolean = false;
    public isVesselBanner: boolean;
    
    constructor(private dialogClientService: DialogClientService, userClaimsService: UserClaimsService) {
        this.rightShipUser = userClaimsService.hasPermission(Claims.RightShipUser);
    }

    activate(model: { bannerGroup: BannerGrouping, isVesselBanner: boolean}) {
        this.isSanctionedBanner = model?.bannerGroup?.internalName?.trim() == 'sanctioned';
        this.isVesselBanner = model.isVesselBanner;
        this.bannerType = this.isSanctionedBanner? model.bannerGroup.displayName: model.bannerGroup.internalName;
        this.bannerListType = model.bannerGroup.internalName;

        if(this.bannerType && this.bannerType.length > 0)
        {
            this.bannerType = StringUtilities.titelize(this.bannerType);
        }

        const bannerSpecificList = model.bannerGroup.response;
        this.bannerDescDialog = { companySpecificLists: [], vesselSpecificLists: [], companyCountrySanctioned: [], vesselCountrySanctioned: [], roleCountrySanctioned: [] };

        Enumerable.from(bannerSpecificList).groupBy(x => x.isCompanyList).forEach(x => {
            const lists = x.toArray();
            const isCompany = lists[0].isCompanyList;

            if (isCompany) {
                this.bannerDescDialog.companySpecificLists = Enumerable.from(lists).where(x => x.listId != null).distinct(x => x.listId).toArray();
            }
            else {
                this.bannerDescDialog.vesselSpecificLists = Enumerable.from(lists).where(x => x.listId != null).distinct(x => x.listId).toArray();
            }
            this.bannerDescDialog.vesselCountrySanctioned = this.bannerDescDialog.vesselCountrySanctioned.concat(lists.filter(x => x.isVesselFlagSanctioned));
            this.bannerDescDialog.companyCountrySanctioned = this.bannerDescDialog.companyCountrySanctioned.concat(lists.filter(x => x.isCountrySanctioned));
            
            if (!this.bannerDescDialog.roleCountrySanctioned)
                this.bannerDescDialog.roleCountrySanctioned = []

            lists.forEach(list => {

                if (list.bocCountrySanctioned) {
                    this.addRoleCountrSactioned('BO', list.countryName);
                }
                if (list.cmcCountrySanctioned) {
                    this.addRoleCountrSactioned('CM', list.countryName);
                }
                if (list.docCountrySanctioned) {
                    this.addRoleCountrSactioned('DOC', list.countryName);
                }
                if (list.rocCountrySanctioned) {
                    this.addRoleCountrSactioned('RO', list.countryName);
                }
                if (list.tmcCountrySanctioned) {
                    this.addRoleCountrSactioned('TM', list.countryName);
                }
                if (list.cocCountrySanctioned) {
                    this.addRoleCountrSactioned('CO', list.countryName);
                }
            });
        });
    }

    private addRoleCountrSactioned(role: string, countryName: string) {
        if (role != null && this.bannerDescDialog.roleCountrySanctioned.findIndex(x => x.role == role && x.country == countryName) == -1)
            this.bannerDescDialog.roleCountrySanctioned.push(<BannerRoleCountrySanctioned>{ role: role, country: countryName });
    }

    close() {
        this.dialogClientService.hide();
    }
}